import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import ProductsList from './ProductsList';
import authHelper from 'helpers/auth';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';

const ProductsListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    const initialFilters = {
        enabled: {
            matchType: filterMatchTypes.equals,
            value: '1',
        },
    };

    const isAdmin = authHelper.isAdmin();

    return (
        <div>
            <Header>
                <Title title={ translate('resources.products.title') } />

                <Actions>

                    { isAdmin && (
                        <CreateButton basePath={ resource } />
                    ) }
                </Actions>
            </Header>

            <ProductsList
                { ...props }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

ProductsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductsListContainer);



// WEBPACK FOOTER //
// ./src/pages/products/list/ProductsListContainer.js